import { render, staticRenderFns } from "./TrafficMap.vue?vue&type=template&id=56d5fa2a&"
import script from "./TrafficMap.vue?vue&type=script&lang=js&"
export * from "./TrafficMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports